import { FormattedMessage as FM } from "react-intl";

import { Alert } from "componentsv2/widgets/Alert";
import HotelSheet from "../Components/HotelSheet";
import MelhousPage from "../Components/MelhousPage";
import SaveBar from "../Components/SaveBar";
import SiteAside from "../Components/SiteAside";
import useHotelForm from "../helpers/useHotelForm";
import { STYLE_SITE_LAYOUT, VIEW_HOTEL } from "../constants";

function MelhousHotel() {
  const hotel = useHotelForm();
  const { form, failed, saveError, saving, dirty } = hotel;

  return (
    <MelhousPage view={VIEW_HOTEL}>
      <div className={STYLE_SITE_LAYOUT}>
        <div className="min-w-0 space-y-4 p-3">
          <p className="text-sm text-neutral-500">
            <FM id="melhous.dash.hotel_notice" />
          </p>
          {failed && (
            <p role="alert" className="text-sm text-red-700">
              <FM id="melhous.dash.hotel.error" />
            </p>
          )}
          {form && (
            <HotelSheet
              form={form}
              defaults={hotel.defaults}
              melhousId={hotel.site.melhous.id}
              onChange={hotel.handleChange}
            />
          )}
          {saveError && (
            <p role="alert" className="text-sm text-red-700">
              <FM id="melhous.dash.hotel.save_error" />
            </p>
          )}
          <Alert
            text="melhous.dash.saved"
            show={hotel.showAlert}
            onClose={hotel.closeAlert}
            color="bg-green-200 text-green-800"
            icon="check"
            autoRemove={true}
          />
          {dirty && <SaveBar saving={saving} onSave={hotel.saveHotel} />}
        </div>
        <div className="px-3 pb-4 lg:pl-0 lg:pr-4 lg:pt-3">
          <SiteAside key={hotel.asideKey} showInherited />
        </div>
      </div>
    </MelhousPage>
  );
}

export default MelhousHotel;
